import type { FC } from 'react';
import type { CheckProps } from '@n3/pn-declaration';

export const Check: FC<CheckProps> = ({ checked }) => (
  <img
    className="checkbox__image"
    src={checked ? '/static/eiop/icons/checked.svg' : '/static/eiop/icons/unchecked.svg'}
    alt=""
    width={16}
    height={16}
  />
);

Check.defaultProps = {
  checked: false,
};
